import { render, staticRenderFns } from "./StockVPT.vue?vue&type=template&id=a5c63ece&scoped=true"
import script from "./StockVPT.vue?vue&type=script&lang=js"
export * from "./StockVPT.vue?vue&type=script&lang=js"
import style0 from "./StockVPT.vue?vue&type=style&index=0&id=a5c63ece&prod&scoped=true&lang=css"
import style1 from "./StockVPT.vue?vue&type=style&index=1&id=a5c63ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c63ece",
  null
  
)

export default component.exports